import { subcategoryRepository } from '@/infrastructure/repositories';
import {
  Subcategory,
  SubcategoriesResponse,
  CreateSubcategoryDto,
  UpdateSubcategoryDto,
  HttpError,
} from '@/domain/entities';

export class SubcategoryService {
  async getSubcategories(categoryId: number): Promise<Subcategory[]> {
    try {
      const response = await subcategoryRepository.getByCategoryId(categoryId);
      return response.subcategories;
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Failed to fetch subcategories');
    }
  }

  async getSubcategory(id: number): Promise<Subcategory> {
    try {
      return await subcategoryRepository.getById(id);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Failed to fetch subcategory');
    }
  }

  async createSubcategory(subcategory: CreateSubcategoryDto): Promise<void> {
    try {
      await subcategoryRepository.create(subcategory);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Failed to create subcategory');
    }
  }

  async updateSubcategory(id: number, updates: UpdateSubcategoryDto): Promise<void> {
    try {
      await subcategoryRepository.update(id, updates);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Failed to update subcategory');
    }
  }

  async deleteSubcategory(id: number): Promise<void> {
    try {
      await subcategoryRepository.delete(id);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Failed to delete subcategory');
    }
  }
}

export const subcategoryService = new SubcategoryService();

